import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
import ClientLogo01 from "../../assets/img/clients/utsav.svg";
import ClientLogo02 from "../../assets/img/clients/svs.svg";
import ClientLogo03 from "../../assets/img/clients/agniveer.png";
import ClientLogo04 from "../../assets/img/clients/logo04.svg";
import ClientLogo05 from "../../assets/img/clients/logo05.svg";
import ClientLogo06 from "../../assets/img/clients/logo06.svg";

// 🔹 Custom Arrow Components
const ArrowButton = ({ className, onClick, direction }) => (
  <Arrow className={className} onClick={onClick} $direction={direction}>
    {direction === "left" ? "‹" : "›"}
  </Arrow>
);

export default function ClientSlider() {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    swipeToSlide: true,
    nextArrow: <ArrowButton direction="right" />,
    prevArrow: <ArrowButton direction="left" />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],
  };

  const clients = [
    { logo: ClientLogo01, name: "Utsav, USA", link: "https://utsavusa.org" },
    {
      logo: ClientLogo02,
      name: "Sanatan Vidyarthi Samsad, Bangladesh",
      link: "https://www.facebook.com/svsbd",
    },
    {
      logo: ClientLogo03,
      name: "Agniveer Bangladesh",
      link: "https://www.agniveerbangla.org/",
    },
    {
      logo: ClientLogo04,
      name: "The Australian Federation for Ethnic and Religious Minorities in Bangladesh Ltd",
      link: "https://www.afermb.org.au/",
    },
  ];

  return (
    <SliderContainer>
      <Slider {...settings}>
        {clients.map((client, idx) => (
          <LogoWrapper key={idx}>
            <a
              href={client.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={client.name}
            >
              <LogoBox>
                <ImgStyle src={client.logo} alt={client.name} />
                <HoverOverlay>{client.name}</HoverOverlay>
              </LogoBox>
            </a>
          </LogoWrapper>
        ))}
      </Slider>
    </SliderContainer>
  );
}

/* ----------------- STYLES ----------------- */

const SliderContainer = styled.div`
  position: relative;

  .slick-track {
    display: flex;
    align-items: center;
  }

  .slick-slide {
    padding: 10px;
  }
`;

/* 🔹 Arrow Styling */
const Arrow = styled.div`
  position: absolute;
  top: 40%;
  z-index: 10;
  font-size: 35px;
  color: #444;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background 0.3s;

  ${(props) => (props.$direction === "left" ? `left: -20px;` : `right: -20px;`)}

  &:hover {
    background: #0073e6;
    color: white;
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  text-align: center;

  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    justify-content: center;
  }

  a:hover {
    transform: scale(1.05);
  }
`;

/* 🔹 Fixed Box for Uniform Logo Size */
const LogoBox = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &:hover img {
    transform: scale(1.05);
  }
`;

const HoverOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 8px 10px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;

  /* allow long names to wrap and stay visible */
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;

  ${LogoBox}:hover & {
    opacity: 1;
  }
`;

const ImgStyle = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
